import { LoanCategory } from '../../../../../../../../../../../types/api';
import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Ruleset } from '../../../interfaces/Ruleset';
import { RulesetResult } from '../../rules';
import IsOwned from '../../rules/IsOwned';
import IsLoanCategoryEqualTo from '../../rules/IsLoanCategoryEqualTo';

class IsOwnPropertyUnderConstructionRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isOwned = IsOwned.evaluate(data);
    const isExpressPropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.EXPRESS_PROPCO
    ).evaluate(data);
    const isExpressPlusPropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.EXPRESS_PLUS_PROPCO
    ).evaluate(data);
    const isCorePropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.CORE_PROPCO
    ).evaluate(data);
    const isIndustryPgPropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.INDUSTRY_PG_PROPCO
    ).evaluate(data);

    return isOwned &&
      (isExpressPlusPropCo ||
        isCorePropCo ||
        isExpressPropCo ||
        isIndustryPgPropCo)
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new IsOwnPropertyUnderConstructionRuleset();
